import { doc, onSnapshot, type Unsubscribe } from 'firebase/firestore'
import {
  bridgePolicySchema,
  type BridgePolicy,
} from '@gh/common/models'
import type { BridgePolicyId } from '@gh/common/models'
import { firestore } from '@/firebase'

export type BridgePolicySnapshotListener = {
  policy: BridgePolicy | null
  error: Error | null
}

export function subscribeBridgePolicy(
  policyId: BridgePolicyId,
  onChange: (state: BridgePolicySnapshotListener) => void,
): Unsubscribe {
  const ref = doc(firestore, 'bridge_policies', policyId)

  return onSnapshot(
    ref,
    (snapshot) => {
      if (!snapshot.exists()) {
        onChange({ policy: null, error: null })
        return
      }

      try {
        const policy = bridgePolicySchema.parse({
          id: snapshot.id,
          ...snapshot.data(),
        })
        onChange({ policy, error: null })
      } catch (error) {
        onChange({
          policy: null,
          error: error instanceof Error ? error : new Error(String(error)),
        })
      }
    },
    (error) => {
      onChange({
        policy: null,
        error: error instanceof Error ? error : new Error(String(error)),
      })
    },
  )
}
